import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';

import useGlobalContext from '../../common/hooks/useGlobalContext';
import styles from './styles';
import Panel from '../../common/elements/Panel';

export const LeftPanel = (props) => {
  const { classes, initialTab, isCarsharing, setRightSidePanelOpen, tabs, title } = props;
  const {
    state: { activeBusinessId },
  } = useGlobalContext();

  const handleChange = (event, newTab) => {
    setSelectedTab(newTab);
    if (isCarsharing && newTab !== 'USER') {
      setRightSidePanelOpen(false);
    }
  };
  const [selectedTab, setSelectedTab] = useState(initialTab);
  useEffect(() => {
    setSelectedTab(initialTab);
    /* For Carsharing, if business entity selection 
    changes default back to company info tab. */
    if (isCarsharing) {
      setSelectedTab('companyInfo');
    }
  }, [activeBusinessId, initialTab, isCarsharing]);

  return (
    <Panel
      title={title}
      modifyPanelClass={classes.leftPanel}
      overrideContentStyle={classes.leftPanelContent}
    >
      <Tabs
        className={classes.tabs}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        value={selectedTab}
        variant="fullWidth"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} value={tab.component.key} />
        ))}
      </Tabs>
      {tabs.filter((tab) => tab.component.key === selectedTab).map(({ component }) => component)}
    </Panel>
  );
};

export default withStyles(styles)(LeftPanel);
